<template>
  <ModalContainer queryParam="observacion" size="lg">
    <b-card>
      <div class="mb-1">Observacion:</div>
      <b-form-textarea
        v-model="obs"
        size="sm"
        rows="3"
        max-rows="6"
        class="custom-textarea"
        placeholder="Escribe tus observaciones aquí..."
      />
      <div class="d-flex justify-content-end">
        <b-button
          variant="primary" 
          class="mt-2"
          @click="onSaveObs"
          :disabled="!obs"
        >
          Guardar
        </b-button>
      </div>
    </b-card>
  </ModalContainer>
  
</template>

<script>
import { ModalContainer } from "@/shared/components";
import { derivacionesService } from '@/views/derivaciones/services';

export default {

  name: "Observacion",

  components: {
    ModalContainer
  },


  data() {
    return {
      tokenDerivacion: null,
      obs: null
    }
  },


  created() {
    this.setTokenDerivacion();
  },

  methods: {
    async setTokenDerivacion() {
      this.tokenDerivacion = this.$route.query.observacion;
      if(!this.tokenDerivacion) return;
      const responseSearch = await derivacionesService.getByToken(this.tokenDerivacion );
      if(responseSearch){
        this.obs = responseSearch.observacion;
      }
    },
    async onSaveObs() {
      const responseUpdate = await derivacionesService.completarRegistro({ tokenDerivacion : this.tokenDerivacion, observacion: this.obs });
      if(!responseUpdate) {
        await this.$swal({
          icon: 'error',
          title: 'No se pudo actualizar el codigo validacion ISSFA',
          showConfirmButton: true,
        });

        return;
      }

      await this.$swal({
        icon: 'success',
        title: 'Observacion guardada',
        showConfirmButton: true,
      });

      await this.$refs.modalContainer.closeModal();
      this.$router.go();
    }
  },
  watch: {
    '$route.query.observacion': {
      handler() {
        this.setTokenDerivacion();
      }
    }
  }
};
</script>
